import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import Carousel from "react-multi-carousel";
import { Link } from "gatsby";
import tekLogoMp4 from "../../images/home-update/tek-logo-video.mp4";
import tekLogoWebm from "../../images/home-update/tek-logo-video.webm";

import {
  Feature1,
  Feature2,
  Feature3,
  Feature4,
  Feature5,
  Feature6,
  Feature7,
  Feature8,
  Feature9,
} from "../../../app-constants";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 4,
  },
  tabletlandscape: {
    breakpoint: { max: 1399, min: 768 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 767, min: 576 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 575, min: 0 },
    items: 2,
  },
};

function Banner({ handleShow }) {
  return (
    <>
      <section class="tekrevol__banner tekrevol_gray_bg demo-class">
        <Container>
          <Row>
            <Col
              xs={12}
              md={7}
              lg={7}
              xl={7}
              xxl={7}
              className="mt-auto mb-auto"
            >
              <div className="bann-cont">
                <h1>
                  <span>Digital Transformation Company</span>
                </h1>
                <h2>Full-Stack Tech Enablement for Future-Ready Businesses</h2>
                <p>
                  From adaption to expansion, we are your partners throughout
                  the digital growth cycle. <br className="d-xl-block d-none" />
                </p>
                <span className="btn-pri" onClick={handleShow}>
                  Schedule a Call
                </span>
              </div>
              <div className="feat">
                <div className="feat-wrap">
                  <div className="title">As Seen On</div>
                </div>
                <Carousel
                  responsive={responsive}
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={100000}
                  arrows={false}
                  className="carousel_featured"
                >
                  <div className="featured_item">
                    <div className="featured_img">{Feature2}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature1}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature3}</div>
                  </div>
                  <div className="featured_item">
                    <div className="featured_img">{Feature9}</div>
                  </div>
                  <div className="featured_item">
                    <div className="featured_img">{Feature4}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature5}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature6}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature7}</div>
                  </div>

                  <div className="featured_item">
                    <div className="featured_img">{Feature8}</div>
                  </div>
                </Carousel>
              </div>
            </Col>
            <Col
              xs={12}
              md={5}
              lg={5}
              xl={5}
              xxl={5}
              className="mt-auto mb-auto"
            >
              <div className="bann-img text-center">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-auto mw-100 case-video"
                >
                  <source src={tekLogoWebm} type="video/webm" />
                  <source src={tekLogoMp4} type="video/mp4" />
                </video>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Banner;
